module.exports = __webpack_public_path__ + "img/montage-logo.216b6428.png";